import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import FontSelector from '../FontSelector/FontSelector';

const TextSection = (props) => {
	const [selectedLine, setSelectedLine] = useState();
	const [inputs, setInputs] = useState([]);
	const [showButton, setShowButton] = useState({
		vertical: false,
		horizontal: false,
	});
	const [maxChar, setMaxChar] = useState();
	const [maxLine, setMaxLine] = useState();
	const [textDirection, setTextDirection] = useState('text-v');
	const [zoneData, setZoneData] = useState();
	const [fontList, setFontList] = useState(null);
	const [selectedFont, setSelectedFont] = useState();
	const [selectFont, setSelectFont] = useState(false);
	const selectedZone = props.zone;
	const regex = selectedZone && selectedZone.inputRegex;
	const lines = Array.from({ length: maxLine }, (x, i) => ({
		value: i + 1,
		name: i + 1 + `${i > 0 ? ' lines' : ' line'}`,
	}));

	useEffect(() => {
		let diff = selectedLine - inputs.length;
		let newInputs = [];
		if (diff > 0) {
			newInputs = Array.from({ length: diff }, (x, i) => ({
				value: '',
				placeHolder: '',
			}));
			newInputs = [...inputs, ...newInputs];
			newInputs.forEach((input, i) => {
				input.placeHolder =
					props.stoleMeta &&
					props.stoleMeta.textDecor &&
					props.stoleMeta.textDecor.placeHolder;
			});
		} else if (diff < 0) {
			newInputs = [...inputs];
			newInputs.splice(diff);
		} else {
			newInputs = [...inputs];
		}
		if (zoneData && zoneData.textLines) {
			newInputs.forEach((input, i) => {
				input.value = `${zoneData.textLines[i] || ''}`;
			});
		}
		setInputs([...newInputs]);
		let isEqual = isValueChanged(
			(zoneData && zoneData.textLines) || [],
			newInputs
		);
		let zoneCode = props.zone && props.zone.zoneCode;
		props.setZoneTextStaus((text) => ({ ...text, [zoneCode]: isEqual }));
	}, [selectedLine, zoneData]);

	useEffect(() => {
		let len = zoneData && zoneData.textLines && zoneData.textLines.length;
		len = len ? (len < maxLine ? len : maxLine) : '1';
		setSelectedLine(len);
	}, [zoneData, maxLine]);

	useEffect(() => {
		const decorTypes = props.zone && props.zone.decorTypes;
		setShowButton({
			...showButton,
			vertical: decorTypes && decorTypes.includes('text-v'),
			horizontal: decorTypes && decorTypes.includes('text-h'),
		});
		const data = props.zone && props.zone.data;
		let direction = '';
		if (data && (data.decorType === 'text-v' || data.decorType === 'text-h')) {
			direction = data.decorType;
		} else if (decorTypes) {
			direction = decorTypes.includes('text-v')
				? 'text-v'
				: decorTypes.includes('text-h')
				? 'text-h'
				: '';
		}
		setTextDirection(direction);
		setZoneData(data);
	}, [props && props.zone]);

	const updateInputValue = (value, index) => {
		let values = [...inputs];
		values[index].value = value;
		setInputs(values);
	};

	useEffect(() => {
		if (textDirection === 'text-h') {
			setMaxChar(props.zone && props.zone.maxHorizChar);
			setMaxLine(props.zone && props.zone.maxHorizLines);
		} else {
			setMaxChar(props.zone && props.zone.maxVertChar);
			setMaxLine(props.zone && props.zone.maxVertLines);
		}
	}, [textDirection]);

	useEffect(() => {
		let fonts = {
			font:
				(zoneData && zoneData.font) ||
				(props.defaultFont && props.defaultFont.font) ||
				'',
			pulseFont:
				(zoneData && zoneData.pulseFont) ||
				(props.defaultFont && props.defaultFont.pulseFont) ||
				'',
		};
		setSelectedFont(fonts);
	}, [props.defaultFont, zoneData]);

	const updateData = () => {
		let isEqual = isValueChanged(zoneData.textLines, inputs);
		if (!isEqual) {
			let textLines = [];
			inputs.forEach((input, i) => {
				textLines.push(input.value && input.value.trim() || '');
			});
			let data = {
				decorType: textDirection,
				assetId: null,
				assetName: null,
				groupCode: null,
				upchargeAmt: 0,
				licensedFlag: null,
				textLines: [...textLines],
				font: selectedFont.font || '',
				pulseFont: selectedFont.pulseFont || '',
				designImageUrl: '',
				patchFlag: '',
			};
			props.updateZoneDetails(data);
			let zoneCode = props.zone && props.zone.zoneCode;
			if (props.zoneImagePath[zoneCode])
				props.setZoneImagePath((images) => ({ ...images, [zoneCode]: '' }));
			props.setZoneTextStaus((text) => ({ ...text, [zoneCode]: true }));
		}
	};
	const restrictCharecter = (event) => {
		let pattern = new RegExp(regex);
		if (!pattern.test(event.key)) {
			event.preventDefault();
		}
	};

	useEffect(() => {
		if (
			zoneData &&
			zoneData.decorType &&
			zoneData.decorType !== textDirection &&
			zoneData.decorType !== 'graphic'
		) {
			let data = { ...zoneData, decorType: textDirection, textLines: [] };
			props.updateZoneDetails(data);
			setSelectedLine(1);
			let zoneCode = props.zone && props.zone.zoneCode;
			props.setZoneImagePath((images) => ({ ...images, [zoneCode]: '' }));
		}
	}, [textDirection]);

	useEffect(() => {
		if (props.fontList && props.fontList.length) {
			setFontList(props.fontList);
		} else {
			props.getFontList();
		}
	}, [props.fontList]);

	const isValueChanged = (oldValue, newValue) => {
		let textLines = [];
		newValue.forEach((input, i) => {
			textLines.push(input.value && input.value.trim() || '');
		});
		let prevValue = oldValue || [];
		prevValue = prevValue.filter((text) => text);
		let textEntered = textLines.filter((text) => text);
		let isEqual = false;
		if (textEntered.length) {
			if (textEntered.length !== prevValue.length) {
				isEqual = false;
			} else {
				// Allow duplications by comparing sorted arrays
				let sortedPrev = [...prevValue].sort();
				let sortedCurrent = [...textEntered].sort();
				isEqual = JSON.stringify(sortedPrev) === JSON.stringify(sortedCurrent);
			}
		} else if (!prevValue.length) {
			isEqual = true;
		}
		let prevFont = props.zone && props.zone.data && props.zone.data.font;
		if (selectedFont && prevFont && prevFont !== selectedFont.font)
			isEqual = false;
		return isEqual;
	};

	return (
		<>
			<label className='title_div text-title' htmlFor='selectDropdown'>
				{props.stoleMeta && props.stoleMeta.textDecor.text}
			</label>
			<div className='description_div'>
				{props.stoleMeta &&
					props.stoleMeta.textDecor.description &&
					props.stoleMeta.textDecor.description.replace('<<maxChar>>', maxChar)}
			</div>
			<select
				className='selectDropdown'
				id='selectDropdown'
				onChange={(event) => {
					setSelectedLine(event.target.value);
				}}
				value={selectedLine}>
				{lines.map((obj, index) => (
					<option value={obj.value} key={index}>
						{obj.name}{' '}
					</option>
				))}
			</select>
			<div className='fontSelector'>
				<FontSelector
					options={fontList}
					OptionSelect={(font) => {
						setSelectedFont({
							font: font.consumerFontCode,
							pulseFont: font.pulseFont,
						});
						setSelectFont(false);
						let zoneCode = props.zone && props.zone.zoneCode;
						!inputs.every((e) => !e.value) &&
							props.setZoneTextStaus((text) => ({
								...text,
								[zoneCode]: false,
							}));
					}}
					selectedOption={selectedFont && selectedFont.font}
					title={
						props.stoleMeta &&
						props.stoleMeta.textDecor.font &&
						props.stoleMeta.textDecor.font + ':'
					}
					setSelectFont={setSelectFont}
					selectFont={selectFont}
					stoleMeta={props.stoleMeta}
				/>
			</div>
			{inputs.map((obj, index) => (
				<div className='row m-0' key={index}>
					<label className='mt-2 mr-1' htmlFor={index}>
						{props.stoleMeta && props.stoleMeta.textDecor.text}:
					</label>
					<input
						type='text'
						id={index}
						value={obj.value}
						key={index}
						placeholder={obj.placeHolder}
						className='jos-text-input form-control selectDropdown input-box'
						onChange={(event) => {
							updateInputValue(event.target.value, index);
						}}
						onBlur={() => {
							let isEqual = isValueChanged(zoneData.textLines, inputs);
							let zoneCode = props.zone && props.zone.zoneCode;
							props.setZoneTextStaus((text) => ({
								...text,
								[zoneCode]: isEqual,
							}));
						}}
						maxLength={maxChar}
						onKeyPress={(event) => restrictCharecter(event)}
					/>
				</div>
			))}
			<Button
				variant='primary'
				className={`text-button m-0 float-right`}
				onClick={() => updateData()}>
				{props.stoleMeta && props.stoleMeta.textDecor.confirm}
			</Button>
			<div className='row m-0 section_heading w-100'>
				<div className='col-12 title_div'>
					{props.stoleMeta && props.stoleMeta.textDecor.textDirection}
				</div>
				<div className='col-12 button-div'>
					{showButton.vertical && (
						<Button
							variant={textDirection === 'text-v' ? 'primary' : 'dark'}
							className={`text-button ${
								showButton.vertical && showButton.horizontal ? 'left' : ''
							}`}
							onClick={() => setTextDirection('text-v')}>
							{props.stoleMeta && props.stoleMeta.textDecor.vertical}
						</Button>
					)}
					{showButton.horizontal && (
						<Button
							variant={textDirection === 'text-h' ? 'primary' : 'dark'}
							className='text-button'
							onClick={() => setTextDirection('text-h')}>
							{props.stoleMeta && props.stoleMeta.textDecor.horizontal}
						</Button>
					)}
				</div>
			</div>
		</>
	);
};
export default React.memo(TextSection);
